import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonService } from 'src/app-core/services/common.service';
import { JobsDataModel } from 'src/app/jobs/jobs-data-model';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-orders-status-change-form',
  templateUrl: './orders-status-change-form.component.html',
  styleUrls: ['./orders-status-change-form.component.scss']
})
export class OrdersStatusChangeFormComponent implements OnInit {

  jobsDataModel = new JobsDataModel();
  statusUpdateModel = this.jobsDataModel.bulkStatusUpdateModel;
  orderData: any;
  isFormLoading = false;
  note: string;
  initialStatusId: any;
  initialStatusName: any;
  jobId: string;
  minDate = moment().subtract(3, 'weeks').format();
  isStatusLost = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<OrdersStatusChangeFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MatDialog,
    private toastr: ToastrService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.onLoadItems();
    this.orderData = this.data;
    this.statusUpdateModel.orderId.push(this.orderData.data.orderId);
    this.statusUpdateModel.statusId = this.orderData.data.statusId;
    this.statusUpdateModel.statusName = this.orderData.data.statusName;
    this.statusUpdateModel.oldStatusId = this.orderData.data.oldStatusId;
    this.statusUpdateModel.oldStatusName = this.orderData.data.oldStatusName;
    this.statusUpdateModel.notes = this.note;
    this.jobId = this.activatedRoute.snapshot.queryParams.jobId;
    if (this.statusUpdateModel.statusId === 8) {
      this.minDate = moment().subtract(3, 'months').format();
    }
    if (this.statusUpdateModel.statusId === 4) {
      this.isStatusLost = true;
    }
  }

  onLoadItems() {
    this.statusUpdateModel.serviceDate = moment().format();
    this.statusUpdateModel.serviceTime = moment().format();
  }


  onSave() {
    this.statusUpdateModel.notes = this.note;
    this.statusUpdateModel.serviceDate = moment(this.statusUpdateModel.serviceDate).format('YYYY-MM-DD');
    this.statusUpdateModel.serviceTime = moment(this.statusUpdateModel.serviceTime).format('HH:mm:ss');
    this.isFormLoading = true;
    this.commonService.orderBulkUpdate(this.statusUpdateModel)
      .pipe(finalize(() => (this.isFormLoading = false)))
      .subscribe((response: any) => {
        this.isFormLoading = false;
        if (response.isSuccess) {
          const sendingData = {
            confirmResult: true
          };
          this.dialogRef.close(sendingData);
          this.toastr.success('Status update successfully');
        } else {
          this.dialogRef.close();
          this.toastr.error(response.errors || 'Something Went wrong, Please Re-try.', 'Error!');
        }
      });
  }

  calendarNavigate(): void {
    this.router.navigateByUrl(`app/jobs/job-details/appointments-tasks?jobId=${this.jobId}`);
  }
  onClose(): void {
    this.dialogRef.close(false);
  }


}
